import { APICallV3Get } from 'reactApp/api/APICall';

export class ViewArchiveInfoAPICall extends APICallV3Get {
    _method = 'unzip/view/';
}
